import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutPaymentTypeService } from '@spartacus/checkout/b2b/core';
import { CheckoutPaymentFacade, CheckoutQueryFacade } from '@spartacus/checkout/base/root';
import {
  CommandService,
  EventService,
  OccEndpointsService,
  ProcessSelectors,
  QueryService,
  StateWithProcess,
  UserIdService
} from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { CustomPaymentTypeEnum } from 'src/app/spartacus/custom/model/cart.model';
import { CustomPaymentTypeConnector } from '../connectors/custom-payment-type.connector';
import { PaymentTypeCustom, PaymentTypes } from '../models/custom-checkout.model';
import { GET_PAYMENT_TYPES_PROCESS_ID, StateWithCheckout } from '../store/custom-checkout-state';
import { CheckoutPaymentTypesQueryResetEvent } from "@spartacus/checkout/b2b/root";


@Injectable({
  providedIn: 'root',
})
export class CustomPaymentTypeService extends CheckoutPaymentTypeService {

  constructor(
    protected activeCartFacade: ActiveCartFacade,
    protected userIdService: UserIdService,
    protected queryService: QueryService,
    protected commandService: CommandService,
    protected paymentTypeConnector: CustomPaymentTypeConnector,
    protected eventService: EventService,
    protected checkoutQueryFacade: CheckoutQueryFacade,
    protected checkoutStore: Store<StateWithCheckout>,
    protected processStateStore: Store<StateWithProcess<void>>,
    protected http: HttpClient,
    protected checkoutPaymentFacade: CheckoutPaymentFacade,
    protected occEndpoints: OccEndpointsService,
  ) {
    super(activeCartFacade, userIdService, queryService, commandService, paymentTypeConnector, eventService, checkoutQueryFacade);
  }

  resetPaymentTypes() {
    this.eventService.dispatch({}, CheckoutPaymentTypesQueryResetEvent);
  }

  getStatusPaymentTypes(): Observable<boolean> {
    return this.processStateStore.pipe(
      select(ProcessSelectors.getProcessSuccessFactory(GET_PAYMENT_TYPES_PROCESS_ID)),
    );
  }

  getSelectedPaymentType(): Observable<string> {
    return this.activeCartFacade.getActive().pipe(
      map((cart) => {
        return cart.paymentMode?.code;
      }),
    );
  }

  isAccountPayment(): Observable<boolean> {
    return this.getSelectedPaymentType().pipe(
      map((selected) => selected === CustomPaymentTypeEnum.ACCOUNT_PAYMENT),
    );
  }

  isCardPayment(): Observable<boolean> {
    return this.getSelectedPaymentType().pipe(
      map((selected) => selected === CustomPaymentTypeEnum.CARD_PAYMENT),
    );
  }

  isSequraPayment(): Observable<boolean> {
    return this.getSelectedPaymentType().pipe(
      map((selected) => selected === CustomPaymentTypeEnum.SEQURA_PAYMENT_SP1 || selected === CustomPaymentTypeEnum.SEQURA_PAYMENT_PP3),
    );
  }

  isPaypalPayment(): Observable<boolean> {
    return this.getSelectedPaymentType().pipe(
      map((selected) => selected === CustomPaymentTypeEnum.PAYPAL_PAYMENT),
    );
  }

  getPaymentType(): Observable<PaymentTypeCustom[]> {
    return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.getActiveCartId()]).pipe(
      take(1),
      switchMap(([userId, cartId]) => {
        const url = this.occEndpoints.buildUrl('paymentModes', { urlParams: { userId, cartId } });
        let headers = new HttpHeaders({
          'Content-Type': 'application/json',
        });
        return this.http.get(url, { headers }).pipe(
          filter(Boolean),
          map((data: PaymentTypes) => !!data ? data.paymentModes : [])
        );
      }));
  }
}
